(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/overlay.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/overlay.js');

'use strict';

const formatTime = svs.utils.date.FormatTime;
const {
  useEffect,
  useState
} = React;
const {
  useAtom
} = jotai;
const {
  overlayResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  ResultDetails
} = svs.lyckoplatsen.components.shared_result.react.components;
const Button = svs.ui.ReactButton;
const Overlay = () => {
  const [result, setOverlayResult] = useAtom(overlayResultAtom);
  const resultDate = result.regCloseTime;
  const [animateIn, setAnimateIn] = useState(false);
  const handleTransitionEnd = () => {
    if (!animateIn) {
      setOverlayResult(null);
    }
  };
  const closeOverlay = () => setAnimateIn(false);
  useEffect(() => {
    setAnimateIn(true);
    const overlayElement = document.querySelector('.result-overlay-content-close');
    if (overlayElement) {
      overlayElement.focus();
    }
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        closeOverlay();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return React.createElement("div", {
    className: "lp-map-result-overlay ".concat(animateIn ? 'animate-in' : '')
  }, React.createElement("div", {
    className: "result-overlay-content",
    onTransitionEnd: handleTransitionEnd
  }, React.createElement("div", {
    className: "result-overlay-content-body"
  }, React.createElement("div", {
    className: "result-overlay-content-header "
  }, Boolean(resultDate) && formatTime('EEEE d/M yyyy', resultDate)), React.createElement(Button, {
    className: "result-overlay-content-close",
    onClick: closeOverlay
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, React.createElement("path", {
    d: "M4.06066 2.93933L3 3.99999L10.955 11.9549L3 19.9099L4.06066 20.9706L12.0156 13.0156L19.9706 20.9706L21.0312 19.9099L13.0763 11.9549L21.0312 3.99999L19.9706 2.93933L12.0156 10.8943L4.06066 2.93933Z"
  }))), React.createElement("div", {
    className: "result-overlay-wrapper"
  }, React.createElement(ResultDetails, {
    result: result,
    showBtnCenterSweden: true
  })))), React.createElement("div", {
    className: "result-overlay-dimmer",
    onClick: closeOverlay
  }));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  Overlay
});

 })(window);